import { useCallback, useEffect } from 'react'
import { useSetState } from 'ahooks'
import { transferFenMap2, useSite, findChangedSteps, PieceChagneSite, moveChess } from './chess'
import { isConformRule } from './rules'
import { canGoRoad } from './road'
import './index.less'
import { Toast } from 'antd-mobile'

type Props = {
  type: 'view' | 'game' // 'view' 仅预览 | 'game' 可以点击
  fen: string // 对方走棋fen值
  role?: 'w' | 'b' // “w”表示红方，“b”表示黑方。
  width?: number
}
type Piece = {
  s: string | null // 棋子符号
  x: number // x 坐标
  y: number // y 坐标
}
type State = {
  selectedPiece: Piece | null
  targetPiece: Piece | null
  flag: 'red' | 'black' | null
  playing: boolean
  gameover: boolean
  myturn: boolean
  roads: string[]
  hovers: string[]
  transform: string
  transition: string
}
type Step = {
  fen: string
  // fenMap: any[][]
  fenMap2: any[][]
}

const imageMap: { [key: string]: string } = {
  K: 'red_shuai',
  R: 'red_che',
  N: 'red_ma',
  C: 'red_pao',
  B: 'red_xiang',
  A: 'red_shi',
  P: 'red_bing',
  k: 'black_jiang',
  r: 'black_che',
  n: 'black_ma',
  c: 'black_pao',
  b: 'black_xiang',
  a: 'black_shi',
  p: 'black_zu',
}

const ChessBoard = ({ type = 'view', fen, role = 'w', width = 375 }: Props) => {
  const pieceWidth = (35 * width) / 375
  const [xs, ys, xp, yp] = useSite(width, width, pieceWidth)

  const [state, setState] = useSetState<State>({
    selectedPiece: null, //定义选中的棋子，默认null就当没选
    targetPiece: null, //定义目的棋子存的数据，用于判断是否可吃
    flag: null, //定义状态的，看甲乙哪一方棋手先手了，再赋值，
    playing: false, //定义游戏是未开始
    gameover: false, //定义游戏是未结束
    myturn: true, // 我方走棋
    roads: [], // 可以走的位置xy
    hovers: [], // 标记选中或起始位置
    transform: '', // 动画css3
    transition: 'transform .3s ease',
  })

  // 上一步
  const [, setPrevStep] = useSetState<Step>({
    fen: '',
    fenMap2: [],
  })
  // 当前步
  const [currStep, setCurrStep] = useSetState<Step>({
    fen: '',
    fenMap2: [],
  })
  // addPiece
  const [addPiece, setAddPiece] = useSetState<Piece>({
    s: null,
    x: 0,
    y: 0,
  })

  // useEffect(() => {
  //   console.log(moves)
  // }, [moves])

  /**
   * 处理用户触摸时的方法
   */
  const touchChess = (event: any) => {
    // console.log(event)
    if (type === 'view') return
    if (state.playing) return
    if (state.gameover) return

    // 是否选中棋子
    let selectedId = event.target.id
    const pieceId = selectedId.split('-')[1]
    console.log('pieceId', pieceId)
    const x = Number(pieceId.split('')[0])
    const y = Number(pieceId.split('')[1])
    const s = currStep.fenMap2[y][x]
    const piece: Piece = { s, x, y }

    // 路径
    if (selectedId.split('-')[0] === 'piece') {
      console.log('---选中棋子---', s, x, y)
      const isMyChess = checkIsMyPiece(s)
      if (isMyChess) {
        setState({ selectedPiece: piece })
        drawHover(pieceId)
        // 提示可走位置
        const _roads = canGoRoad(s, x, y, currStep.fenMap2)
        const roads = _roads.map((item) => item[0] + '' + item[1])
        console.log(s, '可走', roads)
        setState({ roads: roads })
      } else {
        if (state.selectedPiece) {
          movePiece(
            state.selectedPiece.s,
            state.selectedPiece.x,
            state.selectedPiece.y,
            piece.s,
            piece.x,
            piece.y,
          ) // 判断走棋（吃子）
        }
      }
    } else {
      console.log('---选中空白---', s, x, y)
      if (state.selectedPiece) {
        movePiece(
          state.selectedPiece.s,
          state.selectedPiece.x,
          state.selectedPiece.y,
          piece.s,
          piece.x,
          piece.y,
        ) // 判断走棋
      } else {
        drawHover(pieceId)
      }
    }
  }

  const checkIsMyPiece = (piece?: string) => {
    if (!piece) return false
    if (role === 'w') {
      const _picec = piece.toUpperCase()
      return _picec === piece
    } else if (role === 'b') {
      const _picec = piece.toLowerCase()
      return _picec === piece
    }
  }

  /**
   * 实现选中棋子 选中状态
   */
  const drawHover = (id: string, clear = true) => {
    console.log('标记选中', id, clear)
    let _hovers = state.hovers
    if (clear) {
      _hovers = []
    }
    _hovers.push(id)
    setState({ hovers: _hovers })
  }

  /**
   * 下棋
   */
  const movePiece = (
    s: string | null,
    sx: number,
    sy: number,
    e: string | null,
    ex: number,
    ey: number,
  ) => {
    if (s) {
      if (isConformRule(s, sx, sy, ex, ey, currStep.fenMap2)) {
        console.log('合规, 可走棋')
        const [_fen, _fenMap2] = moveChess(s, sx, sy, ex, ey, currStep.fenMap2)
        console.log('走棋后', _fenMap2, _fen)
        setPrevStep({ fen: currStep.fen, fenMap2: currStep.fenMap2 })
        setCurrStep({ fen: _fen })
        setState({ roads: [], hovers: [] })
        if (e?.toUpperCase() === 'K') {
          setState({ gameover: true })
          Toast.show('将军')
        }
        playChess(s, sx, sy, ex, ey)
        setTimeout(() => {
          setCurrStep({ fenMap2: _fenMap2 })
          setState({ transform: '', selectedPiece: null })
        }, 300)
      } else {
        console.log('不可走')
        Toast.show('不可走')
      }
    } else {
      console.log('非棋子')
      Toast.show('非棋子')
    }
  }

  /**
   * 棋子走位动画
   */
  const playChess = useCallback(
    (s: string | null, sx: number, sy: number, ex: number, ey: number) => {
      console.log('走棋动画', s, sx, sy, ex, ey)
      setState({
        transition: 'transform .3s ease',
        transform: `translate(${(ex - sx) * xs}px, ${(ey - sy) * ys}px)`,
      })
    },
    [xs, ys, setState],
  )

  /**
   * 复盘上一步下一步 棋子走位动画
   */
  const historyMove = useCallback(
    (sFen: string, eFen: string) => {
      const [{ s, sx, sy, ex, ey }, { s: s2, x: sx2, y: sy2 }] = findChangedSteps(sFen, eFen) as [
        PieceChagneSite,
        Piece,
      ]
      console.log('selectedPiece', s, sx, sy, s2, sx2, sy2)
      s && setState({ selectedPiece: { s, x: sx, y: sy } })
      if (s2) {
        setAddPiece({
          s: s2,
          x: sx2,
          y: sy2,
        })
      }

      setPrevStep({ fen: currStep.fen, fenMap2: currStep.fenMap2 })
      const _fenMap2 = transferFenMap2(eFen)
      setCurrStep({ fen: eFen })
      setState({ roads: [], hovers: [] })
      playChess(s, sx, sy, ex, ey)
      setTimeout(() => {
        setCurrStep({ fenMap2: _fenMap2 })
        setState({ transform: '', selectedPiece: null })
        if (s2) {
          setAddPiece({
            s: null,
            x: 0,
            y: 0,
          })
          setState({ transition: '' })
        }
      }, 300)
    },
    [currStep.fen, currStep.fenMap2, playChess],
  )

  useEffect(() => {
    const map2 = transferFenMap2(fen)
    if (currStep.fen) {
      // 走棋
      setPrevStep(currStep)

      historyMove(currStep.fen, fen)
    } else {
      // 初始棋盘
      setCurrStep({ fen, fenMap2: map2 })
    }
  }, [fen])

  return (
    <div id="board" className="board" style={{ width: width, height: width }} onClick={touchChess}>
      {/* <div className="log">
        <div className='fs12'>prevStep: {prevStep.fen}</div>
        <div className='fs12'>currStep: {currStep.fen}</div>
      </div> */}
      <div className="fangkuai"></div>
      {currStep.fenMap2.length &&
        currStep.fenMap2.map((list, y) => {
          return list.map((item, x) => {
            return item ? (
              <img
                id={`${'piece-' + x + y}`}
                className={`point piece ${state.hovers.includes('' + x + y) ? 'selected' : ''} `}
                style={{
                  width: pieceWidth,
                  height: pieceWidth,
                  left: x * xs + xp,
                  top: y * ys + yp,
                  // opacity: state.selectedPiece?.s === item || addPiece.s === item ? 0 : 1,
                  // zIndex: checkIsMyPiece(item) ? 1 : 0,
                  zIndex: state.selectedPiece?.s === item || addPiece.s === item ? 2 : 1,
                  transition: state.transition,
                  transform:
                    addPiece.s !== item &&
                    state.selectedPiece?.x === x &&
                    state.selectedPiece?.y === y
                      ? state.transform
                      : '',
                }}
                key={x + '-' + y}
                src={require(`../../images/${imageMap[item]}.png`)}
                alt=""
              />
            ) : (
              <div
                id={`${'empty-' + x + y}`}
                className={`point empty ${state.hovers.includes('' + x + y) ? 'selected' : ''} ${
                  state.roads.includes('' + x + y) ? 'road' : ''
                }`}
                style={{
                  width: pieceWidth,
                  height: pieceWidth,
                  left: x * xs + xp,
                  top: y * ys + yp,
                  zIndex: 0,
                }}
                key={x + '-' + y}
              ></div>
            )
          })
        })}
      {/* {state.selectedPiece?.s ? (
        <Image
          className='point piece'
          style={{
            width: pieceWidth,
            height: pieceWidth,
            left: Taro.pxTransform(state.selectedPiece.x * xs + xp),
            top: Taro.pxTransform(state.selectedPiece.y * ys + yp),
            zIndex: 2,
            transform: state.transform || '',
          }}
          src={require(`../../images/${imageMap[state.selectedPiece.s]}.png`)}
        ></Image>
      ) : undefined} */}
      {addPiece.s ? (
        <img
          className="point piece"
          style={{
            width: pieceWidth,
            height: pieceWidth,
            left: addPiece.x * xs + xp,
            top: addPiece.y * ys + yp,
            zIndex: 0,
          }}
          src={require(`../../images/${imageMap[addPiece.s]}.png`)}
          alt=""
        />
      ) : undefined}
    </div>
  )
}

export default ChessBoard
